import { ObjectType, Field, InputType, Int, ID } from 'type-graphql'
import { ObjectRef, ScalarObject } from '@things-factory/shell'

import { UserPreference } from './user-preference'

@InputType()
export class NewUserPreference {
  @Field(type => ObjectRef)
  user: ObjectRef

  @Field()
  key: string

  @Field(type => ScalarObject, { nullable: false })
  preference: { [key: string]: any }
}

@InputType()
export class UserPreferencePatch {
  @Field(type => ID, { nullable: true })
  id?: string

  @Field(type => ObjectRef)
  user?: ObjectRef

  @Field()
  key?: string

  @Field(type => ScalarObject, { nullable: false })
  preference?: { [key: string]: any }

  @Field({ nullable: true })
  cuFlag?: string
}

@ObjectType()
export class UserPreferenceList {
  @Field(type => [UserPreference])
  items: UserPreference[]

  @Field(type => Int)
  total: number
}
